/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum BloodManagementTerminateAliases {
  BLOOD_MANAGEMENT_TERMINATE_FORM = 'blood-management-terminate-form',
  BLOOD_MANAGEMENT_TERMINATE_LAYOUT = 'blood-management-terminate-layout',
  CONTEXTUAL_BAR_FORM = 'contextual-bar-form',
  DATE_FIELD = 'date-field',
  DATE_INPUT = 'date-input',
  DISCARDED_VOLUME_FIELD = 'discarded-volume-field',
  DISCARDED_VOLUME_INPUT = 'discarded-volume-input',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INFUSED_VOLUME_FIELD = 'infused-volume-field',
  INFUSED_VOLUME_INPUT = 'infused-volume-input',
  LAYOUT_CONTENT = 'layout-content',
  NOTES_FIELD = 'notes-field',
  NOTES_TEXT_AREA = 'notes-text-area',
  PANEL_CONTENT = 'panel-content',
  PANEL_FORM = 'panel-form',
  PANEL_HEADER = 'panel-header',
  PARTIAL_VOLUME_FIELD = 'partial-volume-field',
  PARTIAL_VOLUME_INPUT = 'partial-volume-input',
  STAGE_VOLUME_FIELD = 'stage-volume-field',
  STAGE_VOLUME_INPUT = 'stage-volume-input',
  SUSPEND_ITEM_HEADER = 'suspend-item-header',
}
export { BloodManagementTerminateAliases };
